module.exports = require("memoize-one");